import React, {
  useEffect,
  useMemo,
  useState,
} from "react";

import axios from "axios";
import Swal from "sweetalert2";

import ObtieneDatosCookies
  from "../obtieneDatosCookiesUsuario";
import comprueboPermisos
  from "../tools/comprueboPermisos";

const API_BASE =
  "https://wwwa.isepsantafe.net.ar/expedientes";

const ModuloAvisosAusenciasDocentes = () => {
  const Usuario =
    ObtieneDatosCookies();

  const todasLasEscuelas = [
    {
      nombre: "Escuela de Policia",
      permiso: "Escuela de Policia",
    },
    {
      nombre: "Escuela de Investigaciones",
      permiso: "Escuela de Investigaciones",
    },
    {
      nombre: "Escuela Superior",
      permiso: "Escuela Superior",
    },
    {
      nombre: "Escuela de Especialidades",
      permiso: "Escuela de Especialidades",
    },
    {
      nombre: "Extension Comunitaria",
      permiso: "Extension Comunitaria",
    },
    {
      nombre: "Educacion a Distancia",
      permiso: "Educacion a Distancia",
    },
    {
      nombre: "Extracurricular",
      permiso: "Extracurricular",
    },
  ];

  const puedeVerTodasLasEscuelas =
    comprueboPermisos(
      Usuario?.funcion,
      "Veo todas las escuelas Crear Cursos"
    );

  const escuelasPermitidas =
    puedeVerTodasLasEscuelas
      ? todasLasEscuelas
      : todasLasEscuelas.filter(
          (escuela) =>
            comprueboPermisos(
              Usuario?.funcion,
              escuela.permiso
            )
        );

  const normalizarTexto =
    (valor) =>
      String(valor || "")
        .trim()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");

  const puedeVerEscuela =
    (nombreEscuela) => {
      if (puedeVerTodasLasEscuelas) {
        return true;
      }

      const escuelaNormalizada =
        normalizarTexto(nombreEscuela);

      return escuelasPermitidas.some(
        (escuela) =>
          normalizarTexto(
            escuela.nombre
          ) === escuelaNormalizada
      );
    };

  const [avisos, setAvisos] =
    useState([]);

  const [cargando, setCargando] =
    useState(false);

  const [busqueda, setBusqueda] =
    useState("");


  const [
    avisoExpandidoId,
    setAvisoExpandidoId,
  ] = useState(null);


  const cargarAvisos = async () => {
    try {
      setCargando(true);

    
      const responseAvisos =
        await axios.post(
          `${API_BASE}/devuelveAvisosAusenciasDocentes`,
          {},
          {
            withCredentials: true,
          }
        );

      console.log(
        "RESPUESTA AVISOS:",
        responseAvisos.data
      );

      const lista =
        responseAvisos.data?.avisos ||
        responseAvisos.data?.data ||
        responseAvisos.data ||
        [];

      const avisosBase =
        Array.isArray(lista)
          ? lista
          : [];

      let carpetasSanidad = [];

      try {
        const responseSanidad =
          await axios.post(
            `${API_BASE}/devuelveAusenciasDocentesSanidad`,
            {},
            {
              withCredentials: true,
            }
          );

       
        carpetasSanidad =
          Array.isArray(
            responseSanidad.data?.carpetas
          )
            ? responseSanidad.data.carpetas
            : [];
      } catch (errorSanidad) {
        console.error(
          "No se pudo cargar el detalle ampliado de Sanidad:",
          errorSanidad
        );
      }

    

      const avisosEnriquecidos =
        avisosBase.map(
          (aviso) => {
            if (!aviso?.tieneCarpeta) {
              return aviso;
            }

            const carpetaDetalle =
              carpetasSanidad.find(
                (item) =>
                  Number(item?.avisoId) ===
                    Number(aviso?.id) ||
                  (
                    aviso?.carpetaAusencia?.id &&
                    Number(item?.carpetaId) ===
                      Number(
                        aviso.carpetaAusencia.id
                      )
                  )
              );

            if (!carpetaDetalle) {
              return aviso;
            }

            return {
              ...aviso,

              asignacionesDocentePeriodo:
                Array.isArray(
                  carpetaDetalle
                    .asignacionesDocentePeriodo
                )
                  ? carpetaDetalle
                      .asignacionesDocentePeriodo
                  : [],

              cantidadAsignacionesDocentePeriodo:
                carpetaDetalle
                  .cantidadAsignacionesDocentePeriodo ??
                0,

              cantidadClasesDocenteAfectadas:
                carpetaDetalle
                  .cantidadClasesDocenteAfectadas ??
                0,

              carpetaAusencia: {
                ...(aviso.carpetaAusencia || {}),

                diasSolicitados:
                  carpetaDetalle
                    .diasSolicitados ??
                  aviso.carpetaAusencia
                    ?.diasSolicitados ??
                  null,

                diasConfirmados:
                  carpetaDetalle
                    .diasConfirmados ??
                  aviso.carpetaAusencia
                    ?.diasConfirmados ??
                  null,

                estadoGeneral:
                  carpetaDetalle
                    .estadoGeneral ??
                  aviso.carpetaAusencia
                    ?.estadoGeneral ??
                  null,

                estadoSanidad:
                  carpetaDetalle
                    .estadoSanidad ??
                  aviso.carpetaAusencia
                    ?.estadoSanidad ??
                  null,

                estadoEstudio:
                  carpetaDetalle
                    .estadoEstudio ??
                  aviso.carpetaAusencia
                    ?.estadoEstudio ??
                  null,

                usuarioSanidadId:
                  carpetaDetalle
                    .usuarioSanidadId ??
                  aviso.carpetaAusencia
                    ?.usuarioSanidadId ??
                  null,

                observacionesSanidad:
                  carpetaDetalle
                    .observacionesSanidad ??
                  aviso.carpetaAusencia
                    ?.observacionesSanidad ??
                  null,

                fechaIntervencionSanidad:
                  carpetaDetalle
                    .fechaIntervencionSanidad ??
                  aviso.carpetaAusencia
                    ?.fechaIntervencionSanidad ??
                  null,
              },
            };
          }
        );

      const avisosPermitidos =
        avisosEnriquecidos.filter(
          (aviso) => {
            const escuela =
              aviso
                ?.informacionAcademica
                ?.escuela;

            return puedeVerEscuela(
              escuela
            );
          }
        );



      setAvisos(
        avisosPermitidos
      );
    } catch (error) {
      console.error(
        "Error cargando avisos:",
        error
      );

      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data
            ?.message ||
          "No se pudieron obtener los avisos de ausencia.",
      });
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    cargarAvisos();
  }, []);


  const formatearFecha =
    (fecha) => {
      if (!fecha) {
        return "-";
      }

      try {
        const texto =
          String(fecha).trim();

        const match =
          texto.match(
            /^(\d{4})-(\d{2})-(\d{2})/
          );

        if (match) {
          const anio =
            Number(match[1]);

          const mes =
            Number(match[2]);

          const dia =
            Number(match[3]);

          const obj =
            new Date(
              anio,
              mes - 1,
              dia,
              12,
              0,
              0
            );

          return obj.toLocaleDateString(
            "es-AR"
          );
        }

        const obj =
          new Date(texto);

        if (
          Number.isNaN(
            obj.getTime()
          )
        ) {
          return texto;
        }

        return obj.toLocaleDateString(
          "es-AR",
          {
            timeZone:
              "America/Argentina/Buenos_Aires",
          }
        );
      } catch {
        return String(fecha);
      }
    };

  const formatearFechaHora =
    (fecha) => {
      if (!fecha) {
        return "-";
      }

      try {
        const obj =
          new Date(fecha);

        if (
          Number.isNaN(
            obj.getTime()
          )
        ) {
          return String(fecha);
        }

        return obj.toLocaleString(
          "es-AR",
          {
            timeZone:
              "America/Argentina/Buenos_Aires",

            day: "2-digit",
            month: "2-digit",
            year: "numeric",

            hour: "2-digit",
            minute: "2-digit",

            hour12: false,
          }
        );
      } catch {
        return String(fecha);
      }
    };

  // ============================================================
  // HORAS
  // ============================================================

  const formatearHora =
    (hora) => {
      if (!hora) {
        return "-";
      }

      return String(hora)
        .substring(0, 5);
    };

  // ============================================================
  // TIPO AUSENCIA
  // ============================================================

  const formatearTipoAusencia =
    (tipo) => {
      if (!tipo) {
        return "-";
      }

      const mapa = {
        razonesMedicas:
          "Razones médicas",

        razonMedica:
          "Razón médica",

        enfermedad:
          "Enfermedad",

        imprevisto:
          "Imprevisto",

        razonesPersonales:
          "Razones personales",

        capacitacion:
          "Capacitación",
      };

      if (mapa[tipo]) {
        return mapa[tipo];
      }

      return String(tipo)
        .replace(
          /([A-Z])/g,
          " $1"
        )
        .replace(/_/g, " ")
        .trim()
        .replace(
          /^./,
          (letra) =>
            letra.toUpperCase()
        );
    };

  // ============================================================
  // SANIDAD
  // ============================================================

  const obtenerEstadoSanidad =
    (aviso) => {
      return (
        aviso?.carpetaAusencia
          ?.estadoSanidad ||
        "No Corresponde"
      );
    };

  
  const requiereSanidad =
    (aviso) => {
      if (!aviso?.tieneCarpeta) {
        return false;
      }

      const estado =
        obtenerEstadoSanidad(
          aviso
        );

      return [
        "Pendiente",
        "En Revision",
      ].includes(estado);
    };

  // ============================================================
  // TOMA DE CONOCIMIENTO
  // ============================================================

  const registrarTomaConocimiento =
    async (aviso) => {
      if (!aviso?.id) {
        throw new Error(
          "El aviso no posee ID."
        );
      }

      if (!Usuario?.id) {
        throw new Error(
          "No se pudo determinar el usuario."
        );
      }

      const response =
        await axios.post(
          `${API_BASE}/tomarConocimientoAvisoAusencia`,
          {
            avisoId:
              aviso.id,

            usuarioId:
              Usuario.id,
          },
          {
            withCredentials:
              true,
          }
        );

      const fechaToma =
        response.data
          ?.fechaTomaConocimiento ||
        new Date()
          .toISOString();

      const usuarioToma =
        response.data
          ?.usuarioTomoConocimientoId ||
        Usuario.id;

      setAvisos(
        (anteriores) =>
          anteriores.map(
            (item) =>
              item.id ===
              aviso.id
                ? {
                    ...item,

                    fechaTomaConocimiento:
                      fechaToma,

                    usuarioTomoConocimientoId:
                      usuarioToma,

                    tomadoConocimiento:
                      true,
                  }
                : item
          )
      );

      return {
        fechaTomaConocimiento:
          fechaToma,

        usuarioTomoConocimientoId:
          usuarioToma,
      };
    };

  // ============================================================
  // EXPANDIR / CERRAR AVISO
  // ============================================================

  const alternarAviso =
    async (aviso) => {
      /*
       * Si ya está abierto, lo cerramos.
       */
      if (
        avisoExpandidoId ===
        aviso.id
      ) {
        setAvisoExpandidoId(
          null
        );

        return;
      }

      try {
       
        if (
          !aviso
            .fechaTomaConocimiento
        ) {
          await registrarTomaConocimiento(
            aviso
          );
        }

        setAvisoExpandidoId(
          aviso.id
        );
      } catch (error) {
        Swal.fire({
          icon: "error",
          title:
            "No se pudo abrir el aviso",
          text:
            error.response?.data
              ?.message ||
            error.message ||
            "Ocurrió un error.",
        });
      }
    };

  // ============================================================
  // FILTRO
  // ============================================================

  const avisosFiltrados =
    useMemo(() => {
      const texto =
        busqueda
          .trim()
          .toLowerCase();

      if (!texto) {
        return avisos;
      }

      return avisos.filter(
        (aviso) => {
          const info =
            aviso
              .informacionAcademica ||
            {};

          const docente =
            aviso.docente ||
            {};

          const asignacionesPeriodo =
            Array.isArray(
              aviso
                .asignacionesDocentePeriodo
            )
              ? aviso
                  .asignacionesDocentePeriodo
              : [];

          const valoresAsignaciones =
            asignacionesPeriodo.flatMap(
              (item) => [
                item.asignacionId,
                item.materia,
                item.curso,
                item.division,
                item.sede,
                item.escuela,
                item.estado,
                item.condicion,
              ]
            );

          const valores = [
            aviso.id,
            aviso.docenteDni,

            docente.dni,
            docente.apellido,
            docente.nombres,
            docente.nombreCompleto,

            aviso.tipoDeAusencia,

            aviso.estadoCarpeta,

            obtenerEstadoSanidad(
              aviso
            ),

            info.materia,
            info.curso,
            info.division,
            info.sede,
            info.escuela,

            ...valoresAsignaciones,
          ];

          return valores.some(
            (valor) =>
              String(valor || "")
                .toLowerCase()
                .includes(texto)
          );
        }
      );
    }, [
      avisos,
      busqueda,
    ]);

  // ============================================================
  // SEPARAR CON CARPETA / SIN CARPETA
  // ============================================================

  const avisosConCarpeta =
    useMemo(
      () =>
        avisosFiltrados.filter(
          (aviso) =>
            !!aviso.tieneCarpeta
        ),
      [avisosFiltrados]
    );

  const avisosSinCarpeta =
    useMemo(
      () =>
        avisosFiltrados.filter(
          (aviso) =>
            !aviso.tieneCarpeta
        ),
      [avisosFiltrados]
    );


  const gruposCarpetas =
    useMemo(() => {
      const estructura =
        {};

      avisosConCarpeta.forEach(
        (aviso) => {
          const info =
            aviso
              .informacionAcademica ||
            {};

          const escuela =
            info.escuela ||
            "Escuela no informada";

          const sede =
            info.sede ||
            "Sede no informada";

          const curso =
            info.curso ||
            "Curso no informado";

          const division =
            info.division ||
            "Sin división";

          if (
            !estructura[
              escuela
            ]
          ) {
            estructura[
              escuela
            ] = {};
          }

          if (
            !estructura[
              escuela
            ][sede]
          ) {
            estructura[
              escuela
            ][sede] = {};
          }

          if (
            !estructura[
              escuela
            ][sede][curso]
          ) {
            estructura[
              escuela
            ][sede][curso] =
              {};
          }

          if (
            !estructura[
              escuela
            ][sede][curso][
              division
            ]
          ) {
            estructura[
              escuela
            ][sede][curso][
              division
            ] = [];
          }

          estructura[
            escuela
          ][sede][curso][
            division
          ].push(aviso);
        }
      );

      return estructura;
    }, [avisosConCarpeta]);

  

  const resumen =
    useMemo(() => {
      const dnis =
        new Set();

      avisosFiltrados.forEach(
        (aviso) => {
          if (
            aviso.docenteDni
          ) {
            dnis.add(
              String(
                aviso.docenteDni
              )
            );
          }
        }
      );

      const dnisConCarpeta =
        new Set(
          avisosConCarpeta
            .map(
              (a) =>
                a.docenteDni
            )
            .filter(Boolean)
            .map(String)
        );

      const dnisSinCarpeta =
        new Set(
          avisosSinCarpeta
            .map(
              (a) =>
                a.docenteDni
            )
            .filter(Boolean)
            .map(String)
        );

      const sanidad =
        new Set(
          avisosFiltrados
            .filter(
              requiereSanidad
            )
            .map(
              (a) =>
                a.docenteDni
            )
            .filter(Boolean)
            .map(String)
        );

      return {
        docentes:
          dnis.size,

        carpetas:
          dnisConCarpeta.size,

        sinCarpeta:
          dnisSinCarpeta.size,

        sanidad:
          sanidad.size,

        avisos:
          avisosFiltrados.length,
      };
    }, [
      avisosFiltrados,
      avisosConCarpeta,
      avisosSinCarpeta,
    ]);

  // ============================================================
  // RESUMEN POR ESCUELA / SEDE / CURSO
  // ============================================================

  const resumenDestinos =
    useMemo(() => {
      const mapa =
        new Map();

      avisosFiltrados.forEach(
        (aviso) => {
          const info =
            aviso
              .informacionAcademica ||
            {};

          const escuela =
            info.escuela ||
            "Escuela no informada";

          const sede =
            info.sede ||
            "Sede no informada";

          const curso =
            info.curso ||
            "Curso no informado";

          const clave =
            `${escuela}|||${sede}|||${curso}`;

          if (
            !mapa.has(clave)
          ) {
            mapa.set(
              clave,
              {
                escuela,
                sede,
                curso,

                docentes:
                  new Set(),

                avisos: 0,

                sanidad:
                  new Set(),
              }
            );
          }

          const item =
            mapa.get(clave);

          item.avisos++;

          if (
            aviso.docenteDni
          ) {
            item.docentes.add(
              String(
                aviso.docenteDni
              )
            );
          }

          if (
            requiereSanidad(
              aviso
            ) &&
            aviso.docenteDni
          ) {
            item.sanidad.add(
              String(
                aviso.docenteDni
              )
            );
          }
        }
      );

      return Array.from(
        mapa.values()
      )
        .map(
          (item) => ({
            escuela:
              item.escuela,

            sede:
              item.sede,

            curso:
              item.curso,

            docentes:
              item.docentes.size,

            avisos:
              item.avisos,

            sanidad:
              item.sanidad.size,
          })
        )
        .sort(
          (a, b) =>
            `${a.escuela} ${a.sede} ${a.curso}`
              .localeCompare(
                `${b.escuela} ${b.sede} ${b.curso}`,
                "es"
              )
        );
    }, [avisosFiltrados]);

  // ============================================================
  // RENDER
  // ============================================================

  return (
    <div
      style={
        styles.contenedor
      }
    >
      {/* =====================================================
          CABECERA
      ===================================================== */}

      <div
        style={
          styles.header
        }
      >
        <div>
          <h2
            style={
              styles.titulo
            }
          >
            Ausencias docentes
          </h2>

          <div
            style={
              styles.subtitulo
            }
          >
            Avisos registrados
            desde Mi ISeP
          </div>
        </div>

        <button
          type="button"
          onClick={
            cargarAvisos
          }
          disabled={
            cargando
          }
          style={
            styles.botonActualizar
          }
        >
          {cargando
            ? "Actualizando..."
            : "Actualizar"}
        </button>
      </div>



      {/* =====================================================
          RESUMEN GENERAL
      ===================================================== */}

      <div
        style={
          styles.resumenGeneral
        }
      >
        <ResumenNumero
          numero={
            resumen.docentes
          }
          titulo="Docentes"
          descripcion="con ausencia registrada"
        />

        <ResumenNumero
          numero={
            resumen.carpetas
          }
          titulo="Carpeta médica"
          descripcion="docentes con carpeta"
        />

        <ResumenNumero
          numero={
            resumen.sinCarpeta
          }
          titulo="Sin carpeta"
          descripcion="avisos simples"
        />

        <ResumenNumero
          numero={
            resumen.sanidad
          }
          titulo="Sanidad"
          descripcion="requieren intervención"
          alerta={
            resumen.sanidad >
            0
          }
        />

        <ResumenNumero
          numero={
            resumen.avisos
          }
          titulo="Avisos"
          descripcion="registros totales"
        />
      </div>

      {/* =====================================================
          RESUMEN POR DESTINO
      ===================================================== */}

      {resumenDestinos.length >
        0 && (
        <div
          style={
            styles.resumenDestinoBloque
          }
        >
          <div
            style={
              styles.tituloResumenDestino
            }
          >
            Resumen por
            Escuela · Sede · Curso
          </div>

          <div
            style={
              styles.listaResumenDestino
            }
          >
            {resumenDestinos.map(
              (
                item,
                index
              ) => (
                <div
                  key={
                    `${item.escuela}-${item.sede}-${item.curso}-${index}`
                  }
                  style={
                    styles.resumenDestinoFila
                  }
                >
                  <div
                    style={{
                      minWidth:
                        0,
                      flex: 1,
                    }}
                  >
                    <div
                      style={
                        styles.resumenDestinoEscuela
                      }
                    >
                      {
                        item.escuela
                      }
                    </div>

                    <div
                      style={
                        styles.resumenDestinoRuta
                      }
                    >
                      {item.sede}
                      {" · "}
                      {item.curso}
                    </div>
                  </div>

                  <div
                    style={
                      styles.resumenDestinoNumeros
                    }
                  >
                    <span>
                      <b>
                        {
                          item.docentes
                        }
                      </b>{" "}
                      docente
                      {item.docentes !==
                      1
                        ? "s"
                        : ""}
                    </span>

                    {item.sanidad >
                      0 && (
                      <span
                        style={
                          styles.miniSanidad
                        }
                      >
                        ⚕{" "}
                        {
                          item.sanidad
                        }{" "}
                        Sanidad
                      </span>
                    )}
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      )}

      {/* =====================================================
          BUSCADOR
      ===================================================== */}

      <input
        type="text"
        value={
          busqueda
        }
        onChange={(e) =>
          setBusqueda(
            e.target.value
          )
        }
        placeholder="Buscar docente, DNI, escuela, sede, curso, división, materia o estado..."
        style={
          styles.buscador
        }
      />

      {/* =====================================================
          LOADING
      ===================================================== */}

      {cargando &&
      avisos.length ===
        0 ? (
        <div
          style={
            styles.mensaje
          }
        >
          Cargando avisos...
        </div>
      ) : avisosFiltrados.length ===
        0 ? (
        <div
          style={
            styles.mensaje
          }
        >
          No hay avisos para
          mostrar.
        </div>
      ) : (
        <>
          {/* =================================================
              CARPETAS MÉDICAS AGRUPADAS
          ================================================= */}

          {avisosConCarpeta.length >
            0 && (
            <section
              style={
                styles.seccionListado
              }
            >
              <div
                style={
                  styles.cabeceraSeccionListado
                }
              >
                <div>
                  <h3
                    style={
                      styles.tituloListado
                    }
                  >
                    Carpetas de
                    ausencia
                  </h3>

                  <div
                    style={
                      styles.subtituloListado
                    }
                  >
                    Agrupadas por
                    Escuela, Sede,
                    Curso y División
                  </div>
                </div>

                <div
                  style={
                    styles.contadorSeccion
                  }
                >
                  {
                    avisosConCarpeta.length
                  }
                </div>
              </div>

              {Object.entries(
                gruposCarpetas
              ).map(
                ([
                  escuela,
                  sedes,
                ]) => (
                  <div
                    key={
                      escuela
                    }
                    style={
                      styles.grupoEscuela
                    }
                  >
                    {/* ESCUELA */}

                    <div
                      style={
                        styles.cabeceraEscuela
                      }
                    >
                      <span>
                        {
                          escuela
                        }
                      </span>

                      <span
                        style={
                          styles.contadorGrupo
                        }
                      >
                        {contarAvisos(
                          sedes
                        )}{" "}
                        aviso(s)
                      </span>
                    </div>

                    {Object.entries(
                      sedes
                    ).map(
                      ([
                        sede,
                        cursos,
                      ]) => (
                        <div
                          key={
                            `${escuela}-${sede}`
                          }
                          style={
                            styles.grupoSede
                          }
                        >
                          {/* SEDE */}

                          <div
                            style={
                              styles.cabeceraSede
                            }
                          >
                            Sede:{" "}
                            <b>
                              {
                                sede
                              }
                            </b>
                          </div>

                          {Object.entries(
                            cursos
                          ).map(
                            ([
                              curso,
                              divisiones,
                            ]) => (
                              <div
                                key={
                                  `${escuela}-${sede}-${curso}`
                                }
                                style={
                                  styles.grupoCurso
                                }
                              >
                                {/* CURSO */}

                                <div
                                  style={
                                    styles.cabeceraCurso
                                  }
                                >
                                  <span>
                                    {
                                      curso
                                    }
                                  </span>

                                  <span
                                    style={
                                      styles.contadorGrupo
                                    }
                                  >
                                    {contarAvisos(
                                      divisiones
                                    )}
                                  </span>
                                </div>

                                {Object.entries(
                                  divisiones
                                ).map(
                                  ([
                                    division,
                                    lista,
                                  ]) => (
                                    <div
                                      key={
                                        `${escuela}-${sede}-${curso}-${division}`
                                      }
                                      style={
                                        styles.grupoDivision
                                      }
                                    >
                                      {/* DIVISIÓN */}

                                      <div
                                        style={
                                          styles.cabeceraDivision
                                        }
                                      >
                                        División{" "}
                                        <b>
                                          {
                                            division
                                          }
                                        </b>

                                        <span
                                          style={
                                            styles.contadorDivision
                                          }
                                        >
                                          {
                                            lista.length
                                          }{" "}
                                          docente
                                          {lista.length !==
                                          1
                                            ? "s"
                                            : ""}
                                        </span>
                                      </div>

                                      <div
                                        style={
                                          styles.listaCompacta
                                        }
                                      >
                                        {lista.map(
                                          (
                                            aviso
                                          ) => (
                                            <AvisoCompacto
                                              key={
                                                aviso.id
                                              }
                                              aviso={
                                                aviso
                                              }
                                              abierto={
                                                avisoExpandidoId ===
                                                aviso.id
                                              }
                                              onToggle={() =>
                                                alternarAviso(
                                                  aviso
                                                )
                                              }
                                              formatearFecha={
                                                formatearFecha
                                              }
                                              formatearFechaHora={
                                                formatearFechaHora
                                              }
                                              formatearHora={
                                                formatearHora
                                              }
                                              formatearTipoAusencia={
                                                formatearTipoAusencia
                                              }
                                              requiereSanidad={
                                                requiereSanidad(
                                                  aviso
                                                )
                                              }
                                              estadoSanidad={
                                                obtenerEstadoSanidad(
                                                  aviso
                                                )
                                              }
                                            />
                                          )
                                        )}
                                      </div>
                                    </div>
                                  )
                                )}
                              </div>
                            )
                          )}
                        </div>
                      )
                    )}
                  </div>
                )
              )}
            </section>
          )}

          {/* =================================================
              SIN CARPETA
          ================================================= */}

          {avisosSinCarpeta.length >
            0 && (
            <section
              style={
                styles.seccionListado
              }
            >
              <div
                style={
                  styles.cabeceraSeccionListado
                }
              >
                <div>
                  <h3
                    style={
                      styles.tituloListado
                    }
                  >
                    Avisos sin
                    carpeta
                  </h3>

                  <div
                    style={
                      styles.subtituloListado
                    }
                  >
                    Avisos individuales
                    que no generaron
                    carpeta de ausencia
                  </div>
                </div>

                <div
                  style={
                    styles.contadorSeccion
                  }
                >
                  {
                    avisosSinCarpeta.length
                  }
                </div>
              </div>

              <div
                style={
                  styles.listaCompacta
                }
              >
                {avisosSinCarpeta.map(
                  (aviso) => (
                    <AvisoCompacto
                      key={
                        aviso.id
                      }
                      aviso={
                        aviso
                      }
                      abierto={
                        avisoExpandidoId ===
                        aviso.id
                      }
                      onToggle={() =>
                        alternarAviso(
                          aviso
                        )
                      }
                      formatearFecha={
                        formatearFecha
                      }
                      formatearFechaHora={
                        formatearFechaHora
                      }
                      formatearHora={
                        formatearHora
                      }
                      formatearTipoAusencia={
                        formatearTipoAusencia
                      }
                      requiereSanidad={
                        false
                      }
                      estadoSanidad="No Corresponde"
                    />
                  )
                )}
              </div>
            </section>
          )}
        </>
      )}
    </div>
  );
};



// ============================================================
// AVISO COMPACTO + ACORDEÓN
// ============================================================

const AvisoCompacto = ({
  aviso,
  abierto,
  onToggle,
  formatearFecha,
  formatearFechaHora,
  formatearHora,
  formatearTipoAusencia,
  requiereSanidad,
  estadoSanidad,
}) => {
  const info =
    aviso.informacionAcademica ||
    {};

  const docente =
    aviso.docente ||
    {};

  const horarios =
    Array.isArray(
      aviso.horariosAfectados
    )
      ? aviso.horariosAfectados
      : [];

  const carpeta =
    aviso.carpetaAusencia ||
    null;

  const asignacionesPeriodo =
    Array.isArray(
      aviso
        .asignacionesDocentePeriodo
    )
      ? aviso
          .asignacionesDocentePeriodo
      : [];

  const cantidadAsignacionesPeriodo =
    aviso
      .cantidadAsignacionesDocentePeriodo ??
    asignacionesPeriodo.length;

  const cantidadClasesPeriodo =
    aviso
      .cantidadClasesDocenteAfectadas ??
    asignacionesPeriodo.reduce(
      (total, item) =>
        total +
        Number(
          item
            ?.cantidadClasesAfectadas ||
          0
        ),
      0
    );

  const tieneDetallePeriodo =
    asignacionesPeriodo.length >
    0;

  const fueVisto =
    !!aviso
      .fechaTomaConocimiento;

  return (
    <div
      style={{
        ...styles.avisoContenedor,

        ...(requiereSanidad
          ? styles.avisoSanidad
          : {}),
      }}
    >
      {/* =====================================================
          FILA COMPACTA
      ===================================================== */}

      <button
        type="button"
        onClick={
          onToggle
        }
        style={
          styles.avisoFila
        }
      >
        <div
          style={
            styles.avisoDocente
          }
        >
          <div
            style={
              styles.avisoNombre
            }
          >
            {docente.nombreCompleto ||
              `DNI ${aviso.docenteDni}`}
          </div>

          <div
            style={
              styles.avisoDni
            }
          >
            DNI{" "}
            {docente.dni ||
              aviso.docenteDni}
          </div>
        </div>

        <div
          style={
            styles.avisoPeriodo
          }
        >
          <span>
            {formatearFecha(
              aviso.fechaDesde
            )}
          </span>

          <span
            style={{
              opacity: 0.45,
            }}
          >
            →
          </span>

          <span>
            {formatearFecha(
              aviso.fechaHasta
            )}
          </span>
        </div>

        <div
          style={
            styles.avisoMateria
          }
        >
          <div
            style={
              styles.avisoMateriaNombre
            }
          >
            {info.materia ||
              "Materia no informada"}
          </div>

          <div
            style={
              styles.avisoDestinoMini
            }
          >
            {info.escuela ||
              "-"}
            {" · "}
            {info.sede ||
              "-"}
            {" · "}
            {info.curso ||
              "-"}
            {" · Div. "}
            {info.division ||
              "-"}
          </div>

          {aviso.tieneCarpeta &&
            tieneDetallePeriodo && (
            <div
              style={
                styles.avisoImpactoMini
              }
            >
              {cantidadAsignacionesPeriodo}{" "}
              asignación
              {cantidadAsignacionesPeriodo !==
              1
                ? "es"
                : ""}
              {" · "}
              {cantidadClasesPeriodo}{" "}
              clase
              {cantidadClasesPeriodo !==
              1
                ? "s"
                : ""}
              {" afectada"}
              {cantidadClasesPeriodo !==
              1
                ? "s"
                : ""}
            </div>
          )}
        </div>

        <div
          style={
            styles.avisoEstados
          }
        >
          {requiereSanidad && (
            <span
              style={
                styles.alertaSanidad
              }
            >
              ⚕ Requiere
              Sanidad
            </span>
          )}

          {aviso.tieneCarpeta &&
            !requiereSanidad && (
            <EstadoSanidad
              estado={
                estadoSanidad
              }
            />
          )}

          {!aviso.tieneCarpeta && (
            <span
              style={
                styles.sinCarpetaBadge
              }
            >
              Sin carpeta
            </span>
          )}

          {!fueVisto && (
            <span
              style={
                styles.noLeido
              }
            >
              ● Nuevo
            </span>
          )}

          <span
            style={
              styles.chevron
            }
          >
            {abierto
              ? "▲"
              : "▼"}
          </span>
        </div>
      </button>

      {/* =====================================================
          DETALLE DESPLEGADO
      ===================================================== */}

      {abierto && (
        <div
          style={
            styles.detalleExpandido
          }
        >
          {/* ALERTA SANIDAD */}

          {requiereSanidad && (
            <div
              style={
                styles.alertaSanidadGrande
              }
            >
              <div
                style={
                  styles.alertaSanidadTitulo
                }
              >
                ⚕ Requiere
                intervención de
                Sanidad
              </div>

              <div>
                Estado actual:{" "}
                <b>
                  {
                    estadoSanidad
                  }
                </b>
              </div>
            </div>
          )}

          {/* RESUMEN */}

          <div
            style={
              styles.detalleResumen
            }
          >
            <DatoMini
              titulo="Motivo"
              valor={
                formatearTipoAusencia(
                  aviso.tipoDeAusencia
                )
              }
            />

            <DatoMini
              titulo="Desde"
              valor={
                formatearFecha(
                  aviso.fechaDesde
                )
              }
            />

            <DatoMini
              titulo="Hasta"
              valor={
                formatearFecha(
                  aviso.fechaHasta
                )
              }
            />

            <DatoMini
              titulo="Avisado"
              valor={
                formatearFechaHora(
                  aviso.createdAt
                )
              }
            />

            <DatoMini
              titulo="Tomado conocimiento"
              valor={
                formatearFechaHora(
                  aviso.fechaTomaConocimiento
                )
              }
            />

            <DatoMini
              titulo={
                aviso.tieneCarpeta
                  ? "Asignaciones afectadas"
                  : "Clases afectadas"
              }
              valor={
                aviso.tieneCarpeta &&
                tieneDetallePeriodo
                  ? cantidadAsignacionesPeriodo
                  : aviso
                      .cantidadClasesAfectadas ??
                    horarios.length
              }
            />

            {aviso.tieneCarpeta &&
              tieneDetallePeriodo && (
              <DatoMini
                titulo="Clases concretas afectadas"
                valor={
                  cantidadClasesPeriodo
                }
              />
            )}
          </div>

          {/* DOCENTE */}

          <DetalleSeccion
            titulo="Docente"
          >
            <div
              style={
                styles.detalleResumen
              }
            >
              <DatoMini
                titulo="Apellido"
                valor={
                  docente.apellido
                }
              />

              <DatoMini
                titulo="Nombres"
                valor={
                  docente.nombres
                }
              />

              <DatoMini
                titulo="DNI"
                valor={
                  docente.dni ||
                  aviso.docenteDni
                }
              />

              <DatoMini
                titulo="Tipo"
                valor={
                  docente.tipo
                }
              />

              <DatoMini
                titulo="Teléfono"
                valor={
                  docente.telefono
                }
              />

              <DatoMini
                titulo="Correo"
                valor={
                  docente.email
                }
              />
            </div>
          </DetalleSeccion>

          {/* ACADÉMICO */}

          <DetalleSeccion
            titulo="Destino académico"
          >
            <div
              style={
                styles.detalleResumen
              }
            >
              <DatoMini
                titulo="Escuela"
                valor={
                  info.escuela
                }
              />

              <DatoMini
                titulo="Sede"
                valor={
                  info.sede
                }
              />

              <DatoMini
                titulo="Curso"
                valor={
                  info.curso
                }
              />

              <DatoMini
                titulo="División"
                valor={
                  info.division
                }
              />

              <DatoMini
                titulo="Materia"
                valor={
                  info.materia
                }
              />

              <DatoMini
                titulo="Asignación"
                valor={
                  info.asignacionId
                    ? `#${info.asignacionId}`
                    : "-"
                }
              />
            </div>
          </DetalleSeccion>

          {/* =================================================
              ACTIVIDAD DOCENTE AFECTADA POR LA CARPETA
          ================================================= */}

          {aviso.tieneCarpeta &&
            tieneDetallePeriodo && (
            <DetalleSeccion
              titulo="Actividad docente afectada por la carpeta"
            >
              <div
                style={
                  styles.impactoResumen
                }
              >
                <div>
                  <b>
                    {
                      cantidadAsignacionesPeriodo
                    }
                  </b>{" "}
                  asignación
                  {cantidadAsignacionesPeriodo !==
                  1
                    ? "es"
                    : ""}{" "}
                  vigente
                  {cantidadAsignacionesPeriodo !==
                  1
                    ? "s"
                    : ""}{" "}
                  durante el período
                </div>

                <div>
                  <b>
                    {
                      cantidadClasesPeriodo
                    }
                  </b>{" "}
                  clase
                  {cantidadClasesPeriodo !==
                  1
                    ? "s"
                    : ""}{" "}
                  concreta
                  {cantidadClasesPeriodo !==
                  1
                    ? "s"
                    : ""}{" "}
                  afectada
                  {cantidadClasesPeriodo !==
                  1
                    ? "s"
                    : ""}
                </div>
              </div>

              <div
                style={
                  styles.listaAsignacionesPeriodo
                }
              >
                {asignacionesPeriodo.map(
                  (
                    asignacionPeriodo,
                    indexAsignacion
                  ) => {
                    const clases =
                      Array.isArray(
                        asignacionPeriodo
                          ?.clasesAfectadas
                      )
                        ? asignacionPeriodo
                            .clasesAfectadas
                        : [];

                    return (
                      <div
                        key={
                          asignacionPeriodo
                            ?.asignacionId ||
                          indexAsignacion
                        }
                        style={
                          styles.asignacionPeriodoCard
                        }
                      >
                        <div
                          style={
                            styles.asignacionPeriodoCabecera
                          }
                        >
                          <div
                            style={{
                              minWidth: 0,
                              flex: 1,
                            }}
                          >
                            <div
                              style={
                                styles.asignacionPeriodoMateria
                              }
                            >
                              {asignacionPeriodo
                                ?.materia ||
                                "Materia no informada"}
                            </div>

                            <div
                              style={
                                styles.asignacionPeriodoDestino
                              }
                            >
                              {asignacionPeriodo
                                ?.escuela ||
                                "Escuela no informada"}
                              {" · "}
                              {asignacionPeriodo
                                ?.sede ||
                                "Sede no informada"}
                              {" · "}
                              {asignacionPeriodo
                                ?.curso ||
                                "Curso no informado"}
                              {" · Div. "}
                              {asignacionPeriodo
                                ?.division ??
                                "-"}
                            </div>
                          </div>

                          <div
                            style={
                              styles.asignacionPeriodoBadges
                            }
                          >
                            {asignacionPeriodo
                              ?.esAsignacionOrigenAviso && (
                              <span
                                style={
                                  styles.badgeOrigenAviso
                                }
                              >
                                Origen del aviso
                              </span>
                            )}

                            <span
                              style={
                                styles.badgeAsignacion
                              }
                            >
                              #
                              {asignacionPeriodo
                                ?.asignacionId ||
                                "-"}
                            </span>
                          </div>
                        </div>

                        <div
                          style={
                            styles.asignacionPeriodoDatos
                          }
                        >
                          <span>
                            Cargo:{" "}
                            <b>
                              {formatearFecha(
                                asignacionPeriodo
                                  ?.fechaInicioAsignacion
                              )}
                            </b>
                            {" → "}
                            <b>
                              {asignacionPeriodo
                                ?.fechaFinalizacionAsignacion
                                ? formatearFecha(
                                    asignacionPeriodo
                                      .fechaFinalizacionAsignacion
                                  )
                                : "Sin fecha de finalización"}
                            </b>
                          </span>

                          {asignacionPeriodo
                            ?.condicion && (
                            <span>
                              Condición:{" "}
                              <b>
                                {
                                  asignacionPeriodo
                                    .condicion
                                }
                              </b>
                            </span>
                          )}

                          {asignacionPeriodo
                            ?.horasAsignadas !==
                            null &&
                            asignacionPeriodo
                              ?.horasAsignadas !==
                              undefined && (
                            <span>
                              Horas asignadas:{" "}
                              <b>
                                {
                                  asignacionPeriodo
                                    .horasAsignadas
                                }
                              </b>
                            </span>
                          )}
                        </div>

                        {clases.length >
                        0 ? (
                          <div
                            style={
                              styles.clasesAsignacionBloque
                            }
                          >
                            <div
                              style={
                                styles.clasesAsignacionTitulo
                              }
                            >
                              Clases que no podrá dictar
                            </div>

                            <div
                              style={
                                styles.horariosCompactos
                              }
                            >
                              {clases.map(
                                (
                                  clase,
                                  indexClase
                                ) => (
                                  <span
                                    key={
                                      `${asignacionPeriodo?.asignacionId}-${clase?.fecha}-${clase?.horarioId}-${indexClase}`
                                    }
                                    style={
                                      styles.horarioChipAfectado
                                    }
                                  >
                                    {clase
                                      ?.diaSemana ||
                                      "Día"}{" "}
                                    {formatearFecha(
                                      clase?.fecha
                                    )}
                                    {" · "}
                                    {formatearHora(
                                      clase?.horaInicio
                                    )}
                                    {" - "}
                                    {formatearHora(
                                      clase?.horaFin
                                    )}
                                  </span>
                                )
                              )}
                            </div>
                          </div>
                        ) : (
                          <div
                            style={
                              styles.sinHorarioAsignacion
                            }
                          >
                            <b>
                              ⚠ Asignación afectada
                            </b>
                            {" · "}
                            {asignacionPeriodo
                              ?.observacionAfectacion ||
                              "El cargo está vigente dentro del período de la carpeta, pero no se encontraron horarios configurados."}
                          </div>
                        )}
                      </div>
                    );
                  }
                )}
              </div>
            </DetalleSeccion>
          )}

          {/* HORARIOS LEGACY / AVISO ORIGINAL */}

          {(!aviso.tieneCarpeta ||
            !tieneDetallePeriodo) &&
          horarios.length >
            0 && (
            <DetalleSeccion
              titulo="Clases afectadas"
            >
              <div
                style={
                  styles.horariosCompactos
                }
              >
                {horarios.map(
                  (
                    horario,
                    index
                  ) => (
                    <span
                      key={
                        `${aviso.id}-${horario.fecha}-${index}`
                      }
                      style={
                        styles.horarioChip
                      }
                    >
                      {
                        horario.diaSemana
                      }{" "}
                      {formatearFecha(
                        horario.fecha
                      )}
                      {" · "}
                      {formatearHora(
                        horario.horaInicio
                      )}
                      -
                      {formatearHora(
                        horario.horaFin
                      )}
                    </span>
                  )
                )}
              </div>
            </DetalleSeccion>
          )}

          {/* CARPETA */}

          {carpeta && (
            <DetalleSeccion
              titulo="Carpeta de ausencia"
            >
              <div
                style={
                  styles.detalleResumen
                }
              >
                <DatoMini
                  titulo="Carpeta"
                  valor={
                    `#${carpeta.id}`
                  }
                />

                <DatoMini
                  titulo="Días solicitados"
                  valor={
                    carpeta
                      .diasSolicitados
                  }
                />

                <DatoMini
                  titulo="Días otorgados"
                  valor={
                    carpeta
                      .diasConfirmados ??
                    aviso
                      .diasConfirmados ??
                    "Sin otorgar aún"
                  }
                />

                <DatoMini
                  titulo="Estado general"
                  valor={
                    carpeta
                      .estadoGeneral
                  }
                />

                <DatoMini
                  titulo="Sanidad"
                  valor={
                    carpeta
                      .estadoSanidad
                  }
                />

                <DatoMini
                  titulo="Estudio"
                  valor={
                    carpeta
                      .estadoEstudio
                  }
                />

                <DatoMini
                  titulo="Fecha intervención Sanidad"
                  valor={
                    formatearFechaHora(
                      carpeta
                        .fechaIntervencionSanidad
                    )
                  }
                />
              </div>

              {carpeta
                .observacionesSanidad && (
                <div
                  style={
                    styles.observacion
                  }
                >
                  <b>
                    Observación
                    Sanidad:
                  </b>{" "}
                  {
                    carpeta
                      .observacionesSanidad
                  }
                </div>
              )}
            </DetalleSeccion>
          )}

          <div
            style={
              styles.pieDetalle
            }
          >
            Aviso #
            {aviso.id}

            {" · "}

            {fueVisto
              ? "✓ Tomado en conocimiento"
              : "Pendiente"}
          </div>
        </div>
      )}
    </div>
  );
};

// ============================================================
// ESTADO SANIDAD
// ============================================================

const EstadoSanidad = ({
  estado,
}) => {
  let estilo =
    styles.sanidadNeutro;

  if (
    estado ===
    "Justificado"
  ) {
    estilo =
      styles.sanidadOk;
  }

  if (
    estado ===
    "Injustificado"
  ) {
    estilo =
      styles.sanidadNo;
  }

  if (
    estado ===
      "Pendiente" ||
    estado ===
      "En Revision"
  ) {
    estilo =
      styles.sanidadPendiente;
  }

  return (
    <span
      style={{
        ...styles.estadoSanidad,
        ...estilo,
      }}
    >
      {estado ||
        "No Corresponde"}
    </span>
  );
};

// ============================================================
// RESUMEN
// ============================================================

const ResumenNumero = ({
  numero,
  titulo,
  descripcion,
  alerta = false,
}) => (
  <div
    style={{
      ...styles.resumenCard,

      ...(alerta
        ? styles.resumenCardAlerta
        : {}),
    }}
  >
    <div
      style={
        styles.resumenNumero
      }
    >
      {numero}
    </div>

    <div
      style={
        styles.resumenTitulo
      }
    >
      {titulo}
    </div>

    <div
      style={
        styles.resumenDescripcion
      }
    >
      {descripcion}
    </div>
  </div>
);

// ============================================================
// DETALLE
// ============================================================

const DetalleSeccion = ({
  titulo,
  children,
}) => (
  <div
    style={
      styles.detalleSeccion
    }
  >
    <div
      style={
        styles.detalleSeccionTitulo
      }
    >
      {titulo}
    </div>

    {children}
  </div>
);

const DatoMini = ({
  titulo,
  valor,
}) => (
  <div
    style={
      styles.datoMini
    }
  >
    <div
      style={
        styles.datoMiniTitulo
      }
    >
      {titulo}
    </div>

    <div
      style={
        styles.datoMiniValor
      }
    >
      {valor !== null &&
      valor !== undefined &&
      valor !== ""
        ? valor
        : "-"}
    </div>
  </div>
);

// ============================================================
// CONTAR AVISOS DE OBJETO ANIDADO
// ============================================================

const contarAvisos =
  (objeto) => {
    if (
      Array.isArray(
        objeto
      )
    ) {
      return objeto.length;
    }

    if (
      !objeto ||
      typeof objeto !==
        "object"
    ) {
      return 0;
    }

    return Object.values(
      objeto
    ).reduce(
      (total, valor) =>
        total +
        contarAvisos(
          valor
        ),
      0
    );
  };

// ============================================================
// ESTILOS
// ============================================================

const styles = {
  contenedor: {
    width: "100%",
    maxWidth: "1400px",
    margin: "0 auto",
    padding: "16px",
    boxSizing:
      "border-box",
  },

  // ==========================================================
  // HEADER
  // ==========================================================

  header: {
    display: "flex",
    justifyContent:
      "space-between",
    alignItems:
      "center",
    flexWrap:
      "wrap",
    gap: "12px",
    marginBottom:
      "14px",
  },

  titulo: {
    margin: 0,
    fontSize: "25px",
  },

  subtitulo: {
    marginTop: "3px",
    fontSize: "13px",
    opacity: 0.65,
  },

  botonActualizar: {
    border:
      "1px solid #ccc",
    background: "white",
    borderRadius: "7px",
    padding:
      "8px 13px",
    cursor: "pointer",
  },

  // ==========================================================
  // RESUMEN GENERAL
  // ==========================================================

  resumenGeneral: {
    display: "grid",
    gridTemplateColumns:
      "repeat(auto-fit, minmax(150px, 1fr))",
    gap: "8px",
    marginBottom:
      "12px",
  },

  resumenCard: {
    border:
      "1px solid #e2e2e2",
    borderRadius: "9px",
    padding:
      "11px 13px",
    background: "white",
  },

  resumenCardAlerta: {
    border:
      "1px solid #e0b55e",
    background:
      "#fff9ea",
  },

  resumenNumero: {
    fontSize: "22px",
    fontWeight: "900",
    lineHeight: 1,
  },

  resumenTitulo: {
    marginTop: "5px",
    fontSize: "13px",
    fontWeight: "800",
  },

  resumenDescripcion: {
    marginTop: "2px",
    fontSize: "11px",
    opacity: 0.6,
  },

  // ==========================================================
  // RESUMEN DESTINOS
  // ==========================================================

  resumenDestinoBloque: {
    border:
      "1px solid #e5e5e5",
    borderRadius: "9px",
    padding: "12px",
    marginBottom:
      "12px",
    background:
      "#fafafa",
  },

  tituloResumenDestino: {
    fontWeight: "800",
    fontSize: "13px",
    marginBottom: "8px",
  },

  listaResumenDestino: {
    display: "grid",
    gridTemplateColumns:
      "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "6px",
  },

  resumenDestinoFila: {
    display: "flex",
    justifyContent:
      "space-between",
    alignItems:
      "center",
    gap: "10px",
    background: "white",
    border:
      "1px solid #eee",
    borderRadius: "7px",
    padding:
      "8px 10px",
  },

  resumenDestinoEscuela: {
    fontWeight: "800",
    fontSize: "12px",
  },

  resumenDestinoRuta: {
    marginTop: "2px",
    fontSize: "11px",
    opacity: 0.65,
  },

  resumenDestinoNumeros: {
    display: "flex",
    flexDirection:
      "column",
    alignItems:
      "flex-end",
    fontSize: "11px",
    whiteSpace:
      "nowrap",
  },

  miniSanidad: {
    marginTop: "2px",
    fontWeight: "800",
  },

  // ==========================================================
  // BUSCADOR
  // ==========================================================

  buscador: {
    width: "100%",
    boxSizing:
      "border-box",
    padding:
      "10px 12px",
    borderRadius: "8px",
    border:
      "1px solid #ccc",
    marginBottom:
      "14px",
    fontSize: "14px",
  },

  mensaje: {
    padding: "30px",
    textAlign: "center",
    opacity: 0.65,
  },

  // ==========================================================
  // SECCIONES
  // ==========================================================

  seccionListado: {
    marginBottom:
      "22px",
  },

  cabeceraSeccionListado: {
    display: "flex",
    justifyContent:
      "space-between",
    alignItems:
      "center",
    gap: "10px",
    marginBottom:
      "8px",
  },

  tituloListado: {
    margin: 0,
    fontSize: "18px",
  },

  subtituloListado: {
    marginTop: "2px",
    fontSize: "11px",
    opacity: 0.6,
  },

  contadorSeccion: {
    minWidth: "30px",
    height: "30px",
    borderRadius: "15px",
    border:
      "1px solid #ddd",
    display: "flex",
    alignItems:
      "center",
    justifyContent:
      "center",
    fontSize: "12px",
    fontWeight: "800",
  },

  // ==========================================================
  // GRUPOS
  // ==========================================================

  grupoEscuela: {
    border:
      "1px solid #ddd",
    borderRadius:
      "10px",
    overflow: "hidden",
    marginBottom:
      "10px",
    background: "white",
  },

  cabeceraEscuela: {
    display: "flex",
    justifyContent:
      "space-between",
    alignItems:
      "center",
    padding:
      "10px 12px",
    background:
      "#f5f5f5",
    fontWeight: "900",
    fontSize: "14px",
  },

  grupoSede: {
    borderTop:
      "1px solid #eee",
  },

  cabeceraSede: {
    padding:
      "7px 12px",
    fontSize: "12px",
    background:
      "#fafafa",
  },

  grupoCurso: {
    borderTop:
      "1px solid #f0f0f0",
  },

  cabeceraCurso: {
    padding:
      "7px 16px",
    display: "flex",
    justifyContent:
      "space-between",
    fontSize: "12px",
    fontWeight: "800",
  },

  grupoDivision: {
    padding:
      "0 10px 9px 22px",
  },

  cabeceraDivision: {
    display: "flex",
    alignItems:
      "center",
    gap: "8px",
    padding:
      "6px 0",
    fontSize: "11px",
    opacity: 0.8,
  },

  contadorGrupo: {
    fontSize: "10px",
    opacity: 0.6,
  },

  contadorDivision: {
    fontSize: "10px",
    opacity: 0.6,
  },

  listaCompacta: {
    display: "flex",
    flexDirection:
      "column",
    gap: "5px",
  },

  // ==========================================================
  // AVISO
  // ==========================================================

  avisoContenedor: {
    border:
      "1px solid #e3e3e3",
    borderRadius: "8px",
    overflow: "hidden",
    background: "white",
  },

  avisoSanidad: {
    borderLeft:
      "4px solid #c99d39",
  },

  avisoFila: {
    width: "100%",
    border: "none",
    background: "white",
    display: "grid",

    gridTemplateColumns:
      "minmax(170px, 1.2fr) minmax(140px, .8fr) minmax(220px, 1.5fr) auto",

    gap: "12px",
    alignItems:
      "center",

    padding:
      "9px 11px",

    cursor: "pointer",
    textAlign: "left",
  },

  avisoDocente: {
    minWidth: 0,
  },

  avisoNombre: {
    fontSize: "13px",
    fontWeight: "800",
    whiteSpace:
      "nowrap",
    overflow: "hidden",
    textOverflow:
      "ellipsis",
  },

  avisoDni: {
    marginTop: "1px",
    fontSize: "10px",
    opacity: 0.55,
  },

  avisoPeriodo: {
    display: "flex",
    gap: "5px",
    alignItems:
      "center",
    fontSize: "11px",
    fontWeight: "700",
    whiteSpace:
      "nowrap",
  },

  avisoMateria: {
    minWidth: 0,
  },

  avisoMateriaNombre: {
    fontSize: "12px",
    fontWeight: "700",
    whiteSpace:
      "nowrap",
    overflow: "hidden",
    textOverflow:
      "ellipsis",
  },

  avisoDestinoMini: {
    marginTop: "2px",
    fontSize: "10px",
    opacity: 0.55,
    whiteSpace:
      "nowrap",
    overflow: "hidden",
    textOverflow:
      "ellipsis",
  },

  avisoEstados: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent:
      "flex-end",
    alignItems:
      "center",
    gap: "5px",
  },

  alertaSanidad: {
    border:
      "1px solid #d9b04e",
    background:
      "#fff7df",
    borderRadius:
      "12px",
    padding:
      "3px 7px",
    fontSize: "9px",
    fontWeight: "900",
    whiteSpace:
      "nowrap",
  },

  sinCarpetaBadge: {
    border:
      "1px solid #ddd",
    borderRadius:
      "12px",
    padding:
      "3px 7px",
    fontSize: "9px",
    opacity: 0.7,
  },

  noLeido: {
    fontSize: "9px",
    fontWeight: "800",
  },

  chevron: {
    fontSize: "9px",
    opacity: 0.5,
  },

  // ==========================================================
  // ESTADO SANIDAD
  // ==========================================================

  estadoSanidad: {
    borderRadius:
      "12px",
    padding:
      "3px 7px",
    fontSize: "9px",
    fontWeight: "800",
    border:
      "1px solid #ddd",
    whiteSpace:
      "nowrap",
  },

  sanidadOk: {
    background:
      "#edf7ef",
    borderColor:
      "#a5c6aa",
  },

  sanidadNo: {
    background:
      "#fff0f0",
    borderColor:
      "#ddb0b0",
  },

  sanidadPendiente: {
    background:
      "#fff7df",
    borderColor:
      "#d9b04e",
  },

  sanidadNeutro: {
    background:
      "#f5f5f5",
  },

  // ==========================================================
  // DETALLE
  // ==========================================================

  detalleExpandido: {
    borderTop:
      "1px solid #eee",
    background:
      "#fcfcfc",
    padding:
      "13px",
  },

  alertaSanidadGrande: {
    border:
      "1px solid #dbba67",
    background:
      "#fff9e9",
    borderRadius:
      "8px",
    padding:
      "10px 12px",
    marginBottom:
      "10px",
    fontSize: "12px",
  },

  alertaSanidadTitulo: {
    fontWeight: "900",
    marginBottom:
      "3px",
  },

  detalleResumen: {
    display: "grid",
    gridTemplateColumns:
      "repeat(auto-fit, minmax(145px, 1fr))",
    gap: "6px",
  },

  datoMini: {
    border:
      "1px solid #e8e8e8",
    borderRadius:
      "6px",
    padding:
      "7px 9px",
    background: "white",
    minWidth: 0,
  },

  datoMiniTitulo: {
    fontSize: "9px",
    opacity: 0.55,
    marginBottom: "2px",
  },

  datoMiniValor: {
    fontSize: "11px",
    fontWeight: "700",
    wordBreak:
      "break-word",
  },

  detalleSeccion: {
    borderTop:
      "1px solid #eaeaea",
    paddingTop: "10px",
    marginTop: "10px",
  },

  detalleSeccionTitulo: {
    fontSize: "12px",
    fontWeight: "900",
    marginBottom:
      "7px",
  },

  horariosCompactos: {
    display: "flex",
    flexWrap: "wrap",
    gap: "5px",
  },

  horarioChip: {
    border:
      "1px solid #ddd",
    borderRadius:
      "12px",
    padding:
      "4px 7px",
    fontSize: "10px",
    background: "white",
  },

  observacion: {
    marginTop: "8px",
    padding:
      "8px 10px",
    border:
      "1px solid #ddd",
    borderRadius:
      "6px",
    background: "white",
    fontSize: "11px",
    lineHeight: 1.5,
  },

  avisoImpactoMini: {
    marginTop: "3px",
    fontSize: "9px",
    fontWeight: "800",
    opacity: 0.78,
  },

  impactoResumen: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px 18px",
    padding: "8px 10px",
    marginBottom: "8px",
    border: "1px solid #dfe6ea",
    borderRadius: "7px",
    background: "#f8fafb",
    fontSize: "11px",
  },

  listaAsignacionesPeriodo: {
    display: "flex",
    flexDirection: "column",
    gap: "7px",
  },

  asignacionPeriodoCard: {
    border: "1px solid #dedede",
    borderRadius: "8px",
    background: "white",
    padding: "9px 10px",
  },

  asignacionPeriodoCabecera: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: "10px",
  },

  asignacionPeriodoMateria: {
    fontSize: "12px",
    fontWeight: "900",
    wordBreak: "break-word",
  },

  asignacionPeriodoDestino: {
    marginTop: "2px",
    fontSize: "10px",
    opacity: 0.65,
    lineHeight: 1.4,
  },

  asignacionPeriodoBadges: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-end",
    gap: "4px",
  },

  badgeOrigenAviso: {
    border: "1px solid #b9c9d3",
    background: "#f0f6f9",
    borderRadius: "12px",
    padding: "3px 6px",
    fontSize: "8px",
    fontWeight: "900",
    whiteSpace: "nowrap",
  },

  badgeAsignacion: {
    border: "1px solid #ddd",
    borderRadius: "12px",
    padding: "3px 6px",
    fontSize: "8px",
    fontWeight: "800",
    whiteSpace: "nowrap",
  },

  asignacionPeriodoDatos: {
    display: "flex",
    flexWrap: "wrap",
    gap: "4px 14px",
    marginTop: "7px",
    paddingTop: "6px",
    borderTop: "1px solid #f0f0f0",
    fontSize: "9px",
    opacity: 0.78,
  },

  clasesAsignacionBloque: {
    marginTop: "8px",
  },

  clasesAsignacionTitulo: {
    marginBottom: "5px",
    fontSize: "9px",
    fontWeight: "900",
  },

  horarioChipAfectado: {
    border: "1px solid #cfd8dc",
    borderRadius: "12px",
    padding: "4px 7px",
    fontSize: "9px",
    background: "#f8fafb",
    fontWeight: "700",
  },

  sinHorarioAsignacion: {
    marginTop: "8px",
    padding: "7px 9px",
    border: "1px solid #e0c37c",
    borderRadius: "6px",
    background: "#fff9e8",
    fontSize: "10px",
    lineHeight: 1.45,
  },

  pieDetalle: {
    marginTop: "10px",
    paddingTop: "8px",
    borderTop:
      "1px solid #eee",
    fontSize: "9px",
    opacity: 0.5,
    textAlign: "right",
  },
};

export default ModuloAvisosAusenciasDocentes;